import "./pages/authentication/utils/smsLinkCredential";
import "./pages/authentication/utils/emailLinkCredential";
import { ColorModeScript } from "@chakra-ui/react"
import * as React from "react"
import * as ReactDOM from "react-dom/client"
import { App } from "./App"
import reportWebVitals from "./reportWebVitals"
import * as serviceWorker from "./serviceWorker"
import { brandConfig, generateCSSCustomProperties } from "./brandConfig"
import { HelmetProvider } from "react-helmet-async"

// Inject CSS custom properties
const style = document.createElement("style");
style.textContent = generateCSSCustomProperties();
document.head.appendChild(style);

// Set document title and meta description
document.title = brandConfig.siteName;
const metaDescription = document.querySelector("meta[name=\"description\"]");
if (metaDescription) {
  metaDescription.setAttribute("content", brandConfig.description);
}

// Set favicon if different from default
const favicon = document.querySelector("link[rel=\"icon\"]") as HTMLLinkElement;
// Only override when the value is a real path — CRA substitutes %PUBLIC_URL% in
// HTML only, so a value still carrying the placeholder would 404 at runtime.
if (favicon && brandConfig.logo.favicon && !brandConfig.logo.favicon.includes("%PUBLIC_URL%")) {
  favicon.href = brandConfig.logo.favicon;
}

const container = document.getElementById("root")
if (!container) throw new Error("Failed to find the root element");
const root = ReactDOM.createRoot(container)

console.log("Brand Config:", {
  siteName: brandConfig.siteName,
  tenantId: brandConfig.tenantId,
  colors: brandConfig.colors
});

root.render(
  <React.StrictMode>
    <HelmetProvider>
      {/* Build-time default from the brand pack (theme.ts reads the same value);
          the tenant record's colorMode is applied at runtime by TenantBrandingLoader
          for viewers who never toggled. A viewer's own toggle always wins. */}
      <ColorModeScript initialColorMode={brandConfig.colorMode ?? "dark"} />
      <App />
    </HelmetProvider>
  </React.StrictMode>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
